import { render, staticRenderFns } from "./taxsubmit.vue?vue&type=template&id=b06afadc&"
import script from "./taxsubmit.vue?vue&type=script&lang=js&"
export * from "./taxsubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports